export enum FranchiseEditionAutoCreationType {
  None = 'none',
  SameYearAutoCreation = 'sameYearAutoCreation',
  NextYearAutoCreation = 'nextYearAutoCreation'
}

export enum FranchiseEditionType {
  ByYear = 'byYear',
  Named = 'named'
}

export enum FranchiseType {
  Other = 'other',
  SingleOrganizationEvent = 'singleOrganizationEvent',
  MultiOrganizationEvent = 'multiOrganizationEvent'
}

export enum FranchisePriority {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
  Critical = 'critical'
}

export interface IFranchiseEdition {
  id?: number; // required on edit for existing editions
  name?: string; // optional
  brandName?: string;
  // Year is optional in the UI; accept string during editing, send number or null to API
  year?: string | number | null;
  locationCity?: string;
  locationState?: string;
  locationCountry?: string;
  activityType?: string;
  disableComparison?: boolean;
  isDeleted?: boolean;
}

export interface IFranchise {
  id?: number; // ignored on edit payload (id goes on URL)
  name: string; // required
  type: FranchiseType;
  priority: FranchisePriority;
  editions: IFranchiseEdition[];
  editionType: FranchiseEditionType;
  editionAutoCreation?: FranchiseEditionAutoCreationType;
  createdAt?: string; // readonly
  createdAtLocal?: string; // readonly
}
